
export const messages = {
  'messages.saved': 'Your application has been saved as a draft.',
  'messages.documentUploaded': 'Document uploaded',
  'messages.documentUploadedDesc': 'has been successfully uploaded.',
  'messages.documentRemoved': 'Document Removed',
  'messages.documentRemovedDesc': 'The document has been removed from the vault',
  'messages.formGenerated': 'Form generated',
  'messages.formGeneratedDesc': 'has been generated and filled with your farm data.',
  'messages.documentDownloaded': 'Document downloaded',
  'messages.documentDownloadedDesc': 'has been downloaded to your device.',
  'messages.scanningDocument': 'Scanning document with OCR...',
  'messages.fieldsDetected': 'fields detected',
  'messages.fillingIn': 'Filling in',
  'messages.formSaved': 'Form saved to your profile. You can now visit the EU Portal.',
  'messages.uploading': 'Uploading',
  'messages.complete': 'Complete',
  'messages.formAutofilled': 'Form autofilled',
  'messages.formAutofilledDesc': 'Your farm profile data has been used to fill in the form.',
  'messages.pdfFormAdded': 'PDF Form added',
  'messages.pdfFormAddedDesc': 'Your completed Irrigation Declaration Form has been uploaded.',
  'messages.docUploadedFromVault': 'Document uploaded from vault',
  'messages.docUploadedFromVaultDesc': 'has been uploaded from your document vault.',
  'messages.appSubmitted': 'Application submitted',
  'messages.appSubmittedDesc': 'Your application has been successfully submitted.',
  'messages.detectedFields': 'Detected fields',
  'messages.autoFilled': 'Auto-filled',
  'messages.remaining': 'remaining',
  'messages.subsidyAttached': 'Subsidy attached to farm',
  'messages.subsidyAttachedDesc': 'The subsidy has been added to your farm profile',
  'messages.simulationComplete': 'Simulation complete',
  'messages.simulationCompleteDesc': 'Your farm simulation has been successfully completed.',
  'messages.simulationSaved': 'Simulation saved',
  'messages.simulationSavedDesc': 'Your simulated farm has been saved as a scenario.',
  'messages.documentAnalyzed': 'Document analyzed',
  'messages.documentAnalyzedDesc': 'The document has been analyzed for potential subsidies.',
  'messages.chatAnalysisComplete': 'Chat analysis complete',
  'messages.chatAnalysisCompleteDesc': 'Potential subsidy matches found based on your description.',
  'messages.unexpectedError': 'An unexpected error occurred',
  'messages.loadError': 'Error loading data',

  // Toast messages - Success
  'messages.success.saved': 'Saved successfully',
  'messages.success.deleted': 'Deleted successfully',
  'messages.success.created': 'Created successfully',
  'messages.success.updated': 'Updated successfully',
  'messages.success.uploaded': 'Uploaded successfully',
  'messages.success.sent': 'Sent successfully',
  'messages.success.copied': 'Copied successfully',
  'messages.success.refreshed': 'Refreshed successfully',
  'messages.success.categorySaved': 'Category saved successfully',
  'messages.success.categoryDeleted': 'Category "{name}" deleted',
  'messages.success.invitationSent': 'Invitation sent',
  'messages.success.profileCreated': 'Profile created successfully',
  'messages.success.searchRefreshed': 'Search refreshed',
  'messages.success.extractionCompleted': 'Structural extraction completed successfully',
  'messages.success.documentReprocessed': 'Document reprocessed with premium model',
  'messages.success.preferencesUpdated': 'Email preferences updated',
  'messages.success.unsubscribed': 'Unsubscribed from all email notifications',
  'messages.success.resubscribed': 'Re-subscribed to email notifications',
  'messages.success.lockReleased': 'Lock released successfully',
  'messages.success.diagnosticsCompleted': 'Diagnostics completed',
  'messages.success.pipelineCompleted': 'Debug pipeline completed!',
  'messages.success.jobCancelled': 'Job cancelled successfully',
  'messages.success.jobScheduledRetry': 'Job scheduled for retry',
  'messages.success.syncCompleted': 'Gentle sync completed!',
  'messages.success.apiSyncCompleted': '{apiSource} sync completed successfully',
  'messages.success.apiSyncDetails': 'Found: {found}, Added: {inserted}, Skipped: {skipped}',
  'messages.success.subsidiesCollected': 'Successfully collected {count} new subsidies!',
  'messages.success.cacheDataRetrieved': 'Enriched data retrieved from cache',
  'messages.success.extractionLogDownloaded': 'Extraction log downloaded',
  'messages.success.aiExtractionCompleted': 'AI extraction completed successfully',
  'messages.success.farmUpdated': 'Farm profile updated successfully',

  // Toast messages - Error
  'messages.error.failed': 'Operation failed',
  'messages.error.loadFailed': 'Failed to load',
  'messages.error.saveFailed': 'Failed to save',
  'messages.error.deleteFailed': 'Failed to delete',
  'messages.error.uploadFailed': 'Failed to upload',
  'messages.error.categorySaveFailed': 'Failed to save category',
  'messages.error.cannotDeleteDefaultCategory': 'Default categories cannot be deleted',
  'messages.error.invalidEmail': 'Please enter a valid email address',
  'messages.error.invitationFailed': 'Failed to send invitation',
  'messages.error.extractionHistoryFailed': 'Failed to load extraction history',
  'messages.error.aiExtractionFailed': 'AI extraction failed',
  'messages.error.userRolesFetchFailed': 'Failed to fetch users and roles',
  'messages.error.syncJobFetchFailed': 'Failed to fetch sync job status',
  'messages.error.apiSyncFailed': 'Failed to sync {apiSource}',
  'messages.error.fullRefreshFailed': 'Full refresh failed',
  'messages.error.collectionFailed': 'Collection failed: {message}',
  'messages.error.lockReleaseFailed': 'Failed to release lock',
  'messages.error.diagnosticsFailed': 'Diagnostics failed',
  'messages.error.systemError': 'System error during extraction',
  'messages.error.pipelineResultsFailed': 'Failed to load pipeline results',
  'messages.error.retryBetterModelFailed': 'Failed to retry with better model',
  'messages.error.emailPreferencesFailed': 'Failed to load email preferences',
  'messages.error.updatePreferenceFailed': 'Failed to update email preference',
  'messages.error.unsubscribeFailed': 'Failed to unsubscribe from emails',
  'messages.error.resubscribeFailed': 'Failed to resubscribe to emails',
  'messages.error.reprocessFailed': 'Failed to reprocess documents',
  'messages.error.jobQueueFailed': 'Failed to load job queue data',
  'messages.error.processJobsFailed': 'Failed to process jobs',
  'messages.error.enqueueJobFailed': 'Failed to enqueue job',
  'messages.error.cancelJobFailed': 'Failed to cancel job',
  'messages.error.retryJobFailed': 'Failed to retry job',
  'messages.error.loadFeedbackFailed': 'Unable to load preferences',
  'messages.error.saveFeedbackFailed': 'Error while saving',
  'messages.error.authenticationRequired': 'You must be logged in for this action',
  'messages.error.noProfileSelected': 'No profile selected',
  'messages.error.invalidSubsidy': 'Invalid subsidy',
  'messages.error.cannotSaveAction': 'Unable to save this action',
  'messages.error.profileNotFound': 'Profile not found',
  'messages.error.profileNotFoundDesc': 'The selected profile no longer exists. Please refresh the page.',
  'messages.error.sessionExpired': 'Session expired',
  'messages.error.sessionExpiredDesc': 'Please log in again',
  'messages.error.databaseError': 'Database error',
  'messages.error.databaseErrorDesc': 'Unable to save your choice',
  'messages.error.hidingError': 'Error while hiding',
  'messages.error.hidingErrorDesc': 'Please try again later',
  'messages.error.deleteFeedbackFailed': 'Error while deleting',
  'messages.error.loadSubsidiesFailed': 'Failed to load subsidies',
  'messages.error.loadMoreSubsidiesFailed': 'Failed to load more subsidies',
  'messages.error.loadTrackedFailed': 'Error while loading',
  'messages.error.addError': 'Error while adding',
  'messages.error.addErrorDesc': 'Please try again',
  'messages.error.selectAtLeastOneSubsidy': 'Please select at least one subsidy',
  'messages.error.invalidCompanyInfo': 'Invalid company information',
  'messages.error.pdfExportFailed': 'Error during PDF export',
  'messages.error.applyExtractionFailed': 'Failed to apply extraction',
  'messages.error.updateFailed': 'Failed to update farm profile',
  'messages.error.reprocessDocumentsFailed': 'Failed to reprocess documents',
  'messages.error.signInRequired': 'Please sign in to star subsidies',
  'messages.error.updateStarredFailed': 'Failed to update starred subsidy',
  'messages.error.updateNotesFailed': 'Failed to update notes',
  'messages.error.updateReminderFailed': 'Failed to update reminder settings',
  'messages.error.queueFailed': 'Failed to start processing',
  'messages.error.processingCompleteFailed': 'Processing completed!',
  'messages.error.processingFailedWithMessage': 'Processing failed: {message}',
  'messages.error.triggerProcessorFailed': 'Processing started but may take longer than usual',
  'messages.error.premiumRetryFailed': 'Failed to retry with better model',
  'messages.error.extractionFailedFallback': 'Local extraction failed',
  'messages.error.extractionFailedFallbackDesc': 'Falling back to cloud extraction',
  'messages.error.localExtractionFailed': 'Local extraction failed',
  'messages.error.localExtractionFailedDesc': 'Will attempt cloud extraction instead',
  'messages.error.uploadIncomplete': 'Upload incomplete',
  'messages.error.uploadIncompleteDesc': 'Extraction attempt not logged. Please try again once upload completes.',
  'messages.error.extractionHistoryLoadFailed': 'Failed to load extraction history',
  'messages.error.aiExtractionStartFailed': 'AI extraction started for {fileName}',
  'messages.error.aiExtractionCompleteSuccess': 'AI extraction completed successfully',
  'messages.error.aiExtractionCompleteSuccessDesc': '{confidence}% confidence, {fieldCount} fields extracted',
  'messages.error.aiExtractionCompleteFailed': 'AI extraction failed',
  'messages.error.aiExtractionCompleteFailedDesc': 'Unknown error occurred',
  'messages.error.enrichedDataRetrieved': 'Enriched data retrieved from cache',
  'messages.error.localAnalysisComplete': 'Local analysis completed ({confidence}% confidence)',
  'messages.error.hybridAnalysisComplete': 'Hybrid analysis completed ({confidence}% confidence)',
  'messages.error.aiAnalysisComplete': 'AI analysis completed ({confidence}% confidence)',
  'messages.error.lowConfidenceAnalysis': 'Local analysis with limited confidence ({confidence}%)',
  'messages.error.noExtractionMethodSucceeded': 'No extraction method succeeded',
  'messages.error.analysisError': 'Analysis error: {message}',
  'messages.error.securityViolation': 'Security Violation: {error}',
  'messages.error.validationError': 'Validation Error: {error}',
  'messages.error.rateLimitExceeded': 'Rate limit exceeded. Please wait before trying again.',
  'messages.error.selectAtLeastOneProfile': 'Please select at least one profile',
  'messages.error.structuralExtractionFailed': 'Extraction error: {message}',
  'messages.error.extractionFailedWithName': 'Extraction failed for {fileName}: {message}',
  'messages.error.saveProfileFailed': 'Failed to save farm profile: {message}',
  'messages.error.companyIdentityUpdateFailed': 'Failed to update company identity',
  'messages.error.companySizeUpdateFailed': 'Failed to update company size',
  'messages.error.sectorActivityUpdateFailed': 'Failed to update sector & activity',
  'messages.error.leadershipUpdateFailed': 'Failed to update leadership',
  'messages.error.geographicPresenceUpdateFailed': 'Failed to update geographic presence',
  'messages.error.aiBusinessIntelligenceUpdateFailed': 'Failed to update AI Business Intelligence',
  'messages.error.documentUploadFailedTitle': 'Upload Failed',
  'messages.error.documentUploadFailedDesc': 'Failed to upload document. Please try again.',

  // Success messages (additional)
  'messages.success.markedInteresting': 'Marked as interesting',
  'messages.success.markedInterestingDesc': 'We will show more similar subsidies',
  'messages.success.markedSaved': 'Marked as interesting',
  'messages.success.markedSavedDesc': 'Saved and we will show more similar subsidies',
  'messages.success.subsidyHidden': 'Subsidy hidden',
  'messages.success.subsidyHiddenDesc': 'We will no longer show similar subsidies',
  'messages.success.preferenceRemoved': 'Preference removed',
  'messages.success.subsidyAdded': 'Subsidy added to your tracking',
  'messages.success.subsidyAddedDesc': 'We are extracting the details for you...',
  'messages.success.pdfExportedCount': 'PDF exported with {count} subsidy',
  'messages.success.pdfExportedCountPlural': 'PDF exported with {count} subsidies',
  'messages.success.appliedFieldsCount': 'Applied {count} fields to farm profile',
  'messages.success.reprocessedCount': 'Reprocessed {successful}/{processed} documents',
  'messages.success.starredRemoved': 'Removed from starred subsidies',
  'messages.success.starredAdded': 'Added to starred subsidies',
  'messages.success.notesUpdated': 'Notes updated',
  'messages.success.remindersEnabled': 'Reminders enabled',
  'messages.success.remindersDisabled': 'Reminders disabled',
  'messages.success.documentQueued': 'Document queued for processing (Job: {jobId})',
  'messages.success.documentProcessingComplete': 'Document processing completed successfully!',
  'messages.success.processingComplete': 'Processing completed!',
  'messages.success.documentProcessedSuccess': 'Document processed successfully! ({time}ms)',
  'messages.success.needsReviewConfidence': 'Document processed but needs manual review ({confidence}% confidence)',
  'messages.success.documentProcessedConfidence': 'Document processed successfully! ({confidence}% confidence)',
  'messages.success.documentReprocessedPremium': 'Document reprocessed with premium model',
  'messages.success.localExtractionComplete': 'Local extraction completed',
  'messages.success.localExtractionCompleteDesc': 'Extracted {count} fields with {confidence}% confidence',
  'messages.success.trackingProgress': 'Tracking extraction progress...',
  'messages.success.hybridExtractionSuccess': 'Document processed using hybrid extraction (rule-based + AI)',
  'messages.success.aiExtractionSuccess': 'Document processed using AI extraction',
  'messages.success.ruleBasedExtractionSuccess': 'Document processed using rule-based extraction',
  'messages.success.subsidyAssignedSingle': 'Subsidy assigned to profile',
  'messages.success.subsidyAssignedMultiple': 'Subsidy assigned to {count} profiles',
  'messages.success.assignmentRemoved': 'Assignment removed',
  'messages.success.structuralExtractionComplete': 'Structural extraction completed successfully',
  'messages.success.highConfidenceApplied': 'High-confidence data from {fileName} applied automatically',
  'messages.success.extractionCompletedReview': 'Extraction completed for {fileName}. Review and apply changes manually.',
  'messages.success.profileUpdated': 'Farm profile updated successfully',
  'messages.success.companyIdentityUpdated': 'Company identity updated successfully',
  'messages.success.companySizeUpdated': 'Company size updated successfully',
  'messages.success.sectorActivityUpdated': 'Sector & activity updated successfully',
  'messages.success.leadershipUpdated': 'Leadership updated successfully',
  'messages.success.geographicPresenceUpdated': 'Geographic presence updated successfully',
  'messages.success.aiBusinessIntelligenceUpdated': 'AI Business Intelligence updated successfully',
  'messages.success.documentUploadedTitle': 'Document Uploaded Successfully',
  'messages.success.documentUploadedDesc': '{documentName} has been added to your application.',

  // Warning messages
  'messages.warning.lowConfidenceExtraction': 'Low confidence local extraction',
  'messages.warning.lowConfidenceExtractionDesc': 'Confidence: {confidence}%. Fallback recommended.',

  // Info messages (additional)
  'messages.info.trackingProgress': 'Tracking extraction progress...',

  // Confirmation messages
  'messages.confirm.deleteCategory': 'Delete category "{name}"?',
  'messages.confirm.delete': 'Are you sure you want to delete this item?',
  'messages.confirm.deleteItem': 'Delete {itemName}?',
  'messages.confirm.deleteItemDescription': 'This action cannot be undone. The {itemName} will be permanently removed.',

  // Info messages
  'messages.info.checkResults': 'Check results below',
  'messages.info.profileReady': 'Your new application profile is ready to use',
  'messages.info.descriptionMessage': 'Description message',
} as const;
